/*-----------------------------------------------------------------
- General translations
-----------------------------------------------------------------*/

export default {
    layout: {
        title      : 'Site title',
        separator  : '::',
        description: 'Quark :: powerful by Quarkino',
    },

    404: {
        title       : 'Page Not Found.',
        back_to_home: 'Go To Home',
    },

    schedule_demo            : 'Schedule Demo',
    request_demo             : 'Request Demo',
    schedule_demo_modal_title: 'Build Beyond Your Expectation',

    header: {
        log_in     : 'Log in',
        sign_up    : 'Get Started',
        client_area: 'Client Area',
        schedule   : 'Schedule Demo',
    },

    footer: {
        find_us_on              : 'Find us on',
        newsletter_section_title: 'Newsletter',
        newsletter_button       : 'Submit',
        placeholder             : 'Your Email',
        success_msg             : 'Your email has been successfully sent.',
        error_msg               : 'A problem occurred, please try again.',
    },
};
